import { render, staticRenderFns } from "./HeaderMiniV2.vue?vue&type=template&id=0aa1c0b2&scoped=true&"
import script from "./HeaderMiniV2.vue?vue&type=script&lang=ts&"
export * from "./HeaderMiniV2.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderMiniV2.vue?vue&type=style&index=0&id=0aa1c0b2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa1c0b2",
  null
  
)

export default component.exports